import http from "./httpService";

class CategoryService {
  async getTermsDropdown(params) {
    const newParams = {
      sort_by: "id",
      order: "desc",
      ...params,
    };
    const url = http.getUrlWithParams("/category-term/dropdown", newParams);
    return await http.get(url);
  }
}

export default new CategoryService();
